import { AnyAction } from "redux"
import { CLOSE_MODAL, OPEN_MODAL } from "./modal-actions"

export interface modalState {
  type: App.ModalTypes
  state: boolean
  metadata?: unknown
}

const INITIAL_STATE: modalState = {
  type: "",
  state: false
}

//This redux reducer is used to manage the state of the modals
export default function modalReducer(state: modalState = INITIAL_STATE, action: AnyAction): modalState {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        type: action.payload.type,
        metadata: action.payload.metadata,
        state: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        type: "",
        state: false
      }

    default:
      return state
  }
}
